'use strict';

var LHDOMElements = function () {
	this.possibleSymbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
	this.isEnableLHDOMElementsReplacer = false
}

LHDOMElements.prototype.init = function () {
	this.saveNames = []
}

LHDOMElements.prototype.one = function ( element, nameEvent, fn )
{
	function customAndRemove ()
	{
		element.removeEventListener(nameEvent, customAndRemove, false)

		fn()
	}

	element.addEventListener(nameEvent, customAndRemove, false)
}

LHDOMElements.prototype.whichAnimationEvent = function () {
	try {
		var t,
		    el = document.createElement("fakeelement");

	  	var animations = {
		    "animation"      : "animationend",
		    "OAnimation"     : "oAnimationEnd",
		    "MozAnimation"   : "animationend",
		    "WebkitAnimation": "webkitAnimationEnd"
	  	}

		for (t in animations){
		    if (el.style[t] !== undefined){
		      	return animations[t];
		    }
		}
	} catch (e) {
		console.error(e)
	}
}

LHDOMElements.prototype.changeAnimate = function ( element, from, to )
{
	this.removeAnimate( element, from )
	this.addAnimate( element, to )
}

LHDOMElements.prototype.addAnimate = function ( element, name )
{
	this.addClass( element, ['lh_animated', name ])
}

LHDOMElements.prototype.removeAnimate = function ( element, name )
{
	this.removeClass( element, ['lh_animated', name ])
}

LHDOMElements.prototype.name = function ( name, original )
{
	this.checkName(name)

	return original ? name : this.saveNames [ name ]
}

/**
 * Удаление класса/классов у элемента
 * 
 * LHDOMElements.removeClass( document.getElementById(''), 'classname')
 * 
 * LHDOMElements.removeClass( document.getElementById(''), ['classname', 'classname', 'classname'])
 * 
 * LHDOMElements.removeClass( document.getElementById(''), 'classname classname classname')
 * 
 * @param  DOM element
 * @param  string|object|array classes
 */
LHDOMElements.prototype.removeClass = function ( element, classes)
{
	var self = this

	if ( typeof classes === 'string' )
	{
		classes = classes.split(' ')
	}

    classes && classes.forEach( function (name) {
        element.classList.remove( self.saveNames[ name ] )
    })

}

/**
 * Проверка класса в массиве сохраненных имен/классов
 * Если класс не обнаружен, добавляет этот класс в массив
 * И генерирует для него уникальный ID
 * @param  {string} name
 * @return {string}
 */
LHDOMElements.prototype.checkName = function ( name )
{
	if ( this.saveNames[ name ] === undefined )
	{
		if ( this.isEnableLHDOMElementsReplacer ) {
			this.saveNames[ name ] = this.generateId( name.length )
		} else {
			this.saveNames[ name ] = name
		}
	}

	return this.saveNames[ name ]
}

/**
 * Добавление класса/классов элементу
 * 
 * LHDOMElements.addClass( document.getElementById(''), 'classname')
 * 
 * LHDOMElements.addClass( document.getElementById(''), ['classname', 'classname', 'classname'])
 * 
 * LHDOMElements.addClass( document.getElementById(''), 'classname classname classname')
 * 
 * @param  DOM element
 * @param  string|object|array classes
 */
LHDOMElements.prototype.addClass = function ( element, classes)
{
	var self = this

	if ( typeof classes === 'string' )
	{
		classes = classes.split(' ')
	}

    classes && classes.forEach( function (name) {
        element.classList.add( self.checkName( name ) )
    })

}

/**
 * Добавление стилей элементу
 *
 * LHDOMElements.addStyle( document.getElementById(''), { display : 'block', opacity : 0 })
 * 
 * @param {[type]} element [description]
 * @param {[type]} styles  [description]
 */
LHDOMElements.prototype.addStyle = function ( element, styles )
{
	var styles = styles || {}

	var css = ''

	Object.keys(styles).forEach( function (key) {
		css += key + ':' + styles[ key ] + '!important;'
	})

	element.style.cssText += css

}

/**
 * Возвращает ближайший родительский элемент (или сам элемент),
 * который соответствует заданному CSS-селектору или null, если таковых элементов вообще нет. 
 * @param  {string} selector
 * @param  {DOM} parent
 * @return {DOM}
 */
LHDOMElements.prototype.closest = function ( selector, parent )
{

	var isClass = selector.search(/^\./g)
	var isId    = selector.search(/^#\#/g)

	if ( isClass )
	{
		selector = selector.replace('#', '')
		return parent.closest( '#' + this.saveNames[ selector ] )
	}

	if ( isId )
	{
		selector = selector.replace('.', '')
		return parent.closest( '.' + this.saveNames[ selector ] )
	}

}

/**
 * Возвращает первый элемент внутри документа,
 * который совпадает с определенной группой селекторов
 * 
 * @param  {string} selector
 * @param  {DOM} parent
 * @return {DOM}
 */
LHDOMElements.prototype.getElement = function ( selector, parent )
{

	var searchIn = document

	if ( parent ) {
		searchIn = parent
	}

	var isClass = selector.search(/^\./g)
	var isId    = selector.search(/^#\#/g)

	if ( isClass )
	{
		selector = selector.replace('#', '')
		return searchIn.querySelector( '#' + this.saveNames[ selector ] )
	}

	if ( isId )
	{
		selector = selector.replace('.', '')
		return searchIn.querySelector( '.' + this.saveNames[ selector ] )
	}

	return searchIn.querySelector( selector )

}

/**
 * Возвращает ссылку на элемент, который имеет атрибут id с указанным значением
 * @param  {string} selector
 * @return {DOM}
 */
LHDOMElements.prototype.getElementById = function ( selector ) {
    return document.getElementById( this.saveNames[ selector ] )
}

/**
 * Возвращает ссылку на элемент, который имеет атрибут class с указанным значением
 * @param  {string} selector
 * @return {DOM}
 */
LHDOMElements.prototype.getElementByClass = function ( selector ) {
    return document.querySelector( '.' + this.saveNames[ selector ] )
}

/**
 * Возвращает ссылку на элементы, которые имеют атрибут class с указанным значением
 * @param  {string} selector
 * @return {DOM}
 */
LHDOMElements.prototype.getElementsByClass = function ( selector, parent ) {

	var searchIn = document

	if ( parent ) {
		searchIn = parent
	}
	
    return searchIn.querySelectorAll( '.' + this.saveNames[ selector ] )
}

/**
 * Генерация строки
 * @param  {integer} length
 * @return {string}
 */
LHDOMElements.prototype.generateId = function (length) {
    let text = ""

    for ( let i = 0; i < length; i++ ) {
        text += this.possibleSymbols.charAt(Math.floor(Math.random() * this.possibleSymbols.length))
    }

    return text;
}

/**
 * Генерация строки с передачей строки и ее длины
 * 
 * LHDOMElements.randomizeName('Привет') => sQwk2E
 * 
 * @param  {string} name
 * @return {string}
 */
LHDOMElements.prototype.randomizeName = function (name) {
    return this.isEnableLHDOMElementsReplacer ? this.generateId( name.length ) : name
}

/**
 * Генерация строки с передачей строки и ее длины
 * Добавление сгенерированного имени в переданный массив
 *
 * LHDOMElements.randomizeNameAndPasteToArray({ test1 : 'AIsdj', test2 : 'aisQjpoei'}, 'just_string')
 * => { test1 : 'sJq4K', test2 : 'kQw4M', 'just_string' : 'uJqR62NcEth'}
 * 
 * @param  {object|array} array
 * @param  {string} name
 * @return {object|array}
 */
LHDOMElements.prototype.randomizeNameAndPasteToArray = function (array, name) {
	
	if ( this.isEnableLHDOMElementsReplacer )
	{
	    array[ name ] = this.generateId( name.length );
	} else {
		array[ name ] = name;
	}

    return array[ name ];
}

/**
 * Создание элемента скрипта
 *
 * LHDOMElements.createScript({
 * 	type : '',
 * 	textContent: '',
 * 	src : '',
 * 	async : '',
 * 	id : '',
 * 	classes : '',
 * 	dataset : ''
 * })
 *
 * Создаст <script type="{type}" src="{src}" async="{async}" id="{id}" class="{classes}" data-{dataset.name}="{dataset.value}"> {textContent} </script>
 * 
 * @param  {object}   options
 * @param  {Function} callback
 * @return {callback or DOM}
 */
LHDOMElements.prototype.createScript = function (options, callback) {
    var options = options || {}

    options.name = 'script'

    var script = this.createElement(options)

    options.type ? ( script.type = options.type ) : ( script.type = 'text/javascript' )

    options.textContent && ( script.textContent = options.textContent )

    options.src  && ( script.src  = options.src  )

    options.async && ( script.async = options.async )

    return callback ? callback(script) : script
}

/**
 * Создание элемента стилей
 *
 * LHDOMElements.createStyle({
 * 	type : '',
 * 	textContent: '',
 * 	id : '',
 * 	classes : '',
 * 	dataset : ''
 * })
 *
 * Создаст <style type="{type}" id="{id}" class="{classes}" data-{dataset.name}="{dataset.value}"> {textContent} </script>
 * 
 * @param  {object}   options
 * @param  {Function} callback
 * @return {callback or DOM}
 */
LHDOMElements.prototype.createStyle = function (options, callback) {
    var options = options || {}

    options.name = 'style'

    var style = this.createElement(options)

    options.media && ( style.media = options.media )

    options.type ? ( style.type = options.type ) : ( style.type = 'text/css' )

    options.textContent && ( style.textContent = options.textContent )

    return callback ? callback(style) : style
}

/**
 * Создание элемента
 *
 * LHDOMElements.createElement({
 * 	name : '',
 * 	id : '',
 * 	classes : '',
 * 	dataset : ''
 * })
 *
 * Создаст <name type="{type}" id="{id}" class="{classes}" data-{dataset.name}="{dataset.value}"></name>
 * 
 * @param  {object}   options
 * @param  {Function} callback
 * @return {callback or DOM}
 */
LHDOMElements.prototype.createElement = function (options, callback) {
    var options = options || {}

    var element = null;

    options.name ? ( element = document.createElement(options.name) ) : ( element = document.createElement('div') )

    options.id && ( element.id = options.id )

    options.classes = options.classes || []

    options.classes && options.classes.forEach( function (name) {
        element.classList.add( name )
    })

    options.dataset = options.dataset || {}

    options.dataset && Object.keys(options.dataset).forEach( function (key) {
        element.dataset[ key ] = options.dataset[ key ]
    })

    return callback ? callback(element) : element
}

/**
 * Вставка нескольких элементов/element в указанный элемент/target
 * @param  {DOM} target
 * @param  {array} elements
 */
LHDOMElements.prototype.appendToChild = function (target, elements) {

	var elements = elements || [];

    elements.forEach( function (element) {
        target.appendChild(element)
    })
}

// Создание объекта
LHDOMElements.prototype.createObjectArray = function (objects) {
    var objects = objects || {}
    return objects
}

// Вставка объекта в массив
LHDOMElements.prototype.insertObjectsToArray = function (objects, _array, id)
{
    _array[ id ] = _array[ id ] || {};

    _array[ id ] = this.createObjectArray( objects )
}

LHDOMElements.prototype.capitalize = function ( string )
{
	return string[0].toUpperCase() + string.slice(1)
}

export let lhdomelements = LHDOMElements
